import { render, staticRenderFns } from "./settleResult.vue?vue&type=template&id=47b21ca8"
import script from "./settleResult.vue?vue&type=script&lang=js"
export * from "./settleResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports